import { render, staticRenderFns } from "./UnBindConfirm.vue?vue&type=template&id=62e82ec7&scoped=true"
import script from "./UnBindConfirm.vue?vue&type=script&lang=js"
export * from "./UnBindConfirm.vue?vue&type=script&lang=js"
import style0 from "./UnBindConfirm.vue?vue&type=style&index=0&id=62e82ec7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e82ec7",
  null
  
)

export default component.exports